import { AppNotification, NotificationPreference, NotificationType } from '../../domain/models/Notification';
import { NotificationRepository } from '../../domain/repositories/NotificationRepository';
import { NotificationDataSource } from '../datasources/NotificationDataSource';
import { notificationEntityToModel, notificationPreferenceEntityToModel } from '../entities/NotificationEntity';

export class NotificationRepositoryImpl implements NotificationRepository {
  constructor(private dataSource: NotificationDataSource) {}

  async registerPushToken(userId: string, token: string, deviceName?: string): Promise<void> {
    await this.dataSource.registerPushToken(userId, token, deviceName);
  }

  async removePushToken(userId: string, token: string): Promise<void> {
    await this.dataSource.removePushToken(userId, token);
  }

  async getNotifications(userId: string, limit?: number, offset?: number): Promise<AppNotification[]> {
    const entities = await this.dataSource.getNotifications(userId, limit, offset);
    return entities.map(notificationEntityToModel);
  }

  async getUnreadCount(userId: string): Promise<number> {
    return await this.dataSource.getUnreadCount(userId);
  }

  async markAsRead(notificationId: string): Promise<void> {
    await this.dataSource.markAsRead(notificationId);
  }

  async markAllAsRead(userId: string): Promise<void> {
    await this.dataSource.markAllAsRead(userId);
  }

  async getPreferences(userId: string): Promise<NotificationPreference[]> {
    const entities = await this.dataSource.getPreferences(userId);
    return entities.map(notificationPreferenceEntityToModel);
  }

  async updatePreference(userId: string, type: NotificationType, enabled: boolean): Promise<void> {
    await this.dataSource.updatePreference(userId, type, enabled);
  }

  async sendNotification(
    userId: string,
    type: NotificationType,
    title: string,
    body: string,
    data?: Record<string, string>
  ): Promise<void> {
    await this.dataSource.sendNotification(userId, type, title, body, data);
  }
}
